/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;



//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/~/lodash/_baseUnary.js
// module id = ./node_modules/victory-chart/node_modules/lodash/_baseUnary.js
// module chunks = 1